import Carousel from "@/components/carousel";
import EventGrid from "@/components/event-grid";
import PhotoSearch from "@/components/photo-search";
import CategoryGrid from "@/components/category-grid";
import { UserControls } from "@/components/UserControls";
import { Link } from "wouter";

export default function Home() {
  return (
    <>
      <Carousel />
      <PhotoSearch />
      <EventGrid limit={9} />
      {/* <CategoryGrid /> */}

      <div className="py-12 sm:py-16 gradient-bg text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6">Faça Parte da FotUP</h2>
          <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Conectamos atletas às suas melhores fotos e oferecemos aos fotógrafos uma plataforma para monetizar seu trabalho.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-stretch sm:items-center max-w-3xl mx-auto">
            <div className="bg-white bg-opacity-10 p-6 rounded-lg backdrop-blur flex-1">
              <i className="fas fa-camera text-3xl sm:text-4xl mb-4"></i>
              <h3 className="text-lg sm:text-xl font-semibold mb-2">Para Fotógrafos</h3>
              <p className="mb-4 text-sm">Monetize suas fotos esportivas com facilidade</p>
              <Link to="/register?type=Photographer">
                <button
                  className="bg-white text-primary px-6 py-2 font-semibold hover:bg-gray-100 transition-colors w-full sm:w-auto"
                  data-testid="button-photographer-signup"
                >
                  Começar Agora
                </button>
              </Link>
            </div>

            <div className="bg-white bg-opacity-10 p-6 rounded-lg backdrop-blur flex-1">
              <i className="fas fa-running text-3xl sm:text-4xl mb-4"></i>
              <h3 className="text-lg sm:text-xl font-semibold mb-2">Para Atletas</h3>
              <p className="mb-4 text-sm">Encontre suas fotos de corrida facilmente</p>
              <Link to="/register?type=Athlete">
                <button
                  className="bg-primary px-6 py-2 font-semibold hover:bg-secondary transition-colors text-primary-foreground w-full sm:w-auto"
                  data-testid="button-athlete-search"
                >
                  Buscar Fotos
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
